import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_PRESIGNED_URL,
  FAILURE_GET_PRESIGNED_URL,
  LOADING_GET_PRESIGNED_URL,
  RESET_GET_PRESIGNED_URL,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getPresignedUrlReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_PRESIGNED_URL:
      return { ...state, loading: true, response: null };
    case SUCCESS_GET_PRESIGNED_URL:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_PRESIGNED_URL:
      return { ...state, loading: false, response: null };
    case RESET_GET_PRESIGNED_URL:
      return initialState;
    default:
      return state;
  }
};
